// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/Venue/Venue.css
// module id = 1610
// module chunks = 0